import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { UserContex } from '../context API/UserContext';

const UpdateService = () => {
     const { id } = useParams();
     const [name, setName] = useState("");
     const [desc, setDesc] = useState("");
     const [userData, setUserData] = useContext(UserContex);
     const navigate = useNavigate();
     useEffect(() => {
       axios
         .get("https://back.waratechnology.com/api/service/gtservice/"+id)
         .then((res) => {
           setName(res.data.data.name);
           setDesc(res.data.data.description);
         })
         .catch((err) => {
           console.log(err);
         });
     }, []);
     const handlesubmit = (e) => {
       e.preventDefault();
       axios
         .post("https://back.waratechnology.com/api/service/stservice/"+id,{name,desc})
         .then((res) => {
           console.log(res.data.msg);
           navigate("/");
         })
         .catch((err) => {
           alert(err.response.data.msg);
           console.log(err.data);
         });
     };
     useEffect(() => {
       if (!userData.user) {
         navigate("/login");
       }
     });
  return (
    <div className="bg-gray-400  flex justify-center items-center h-screen pt-12 ">
      <div className="w-3/4 h-3/4 md:w-1/2 md:h-3/4 bg-white  border border-black-1 border-rounded rounded-2xl p-4 shadow-lg shadow-white-500/50 ">
        <div className="flex justify-center mt-2 mb-4">
          <h1 className=" font-bold text-2xl">Update Service</h1>
        </div>
        <form onSubmit={handlesubmit}>
          <div className="flex my-4">
            <label className="font-bold mr-2">Name</label>
            <input
              value={name}
              placeholder="name"
              type="text"
              className="w-full  pl-2 h-12 md:h-8 border border-gray-300 rounded-2xl"
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="flex my-4">
            <label className=" font-bold mr-2">Description</label>
            <textarea
              value={desc}
              rows="5"
              cols="20"
              onChange={(e) => setDesc(e.target.value)}
              placeholder="description"
              className="w-full pl-2 border border-gray-300 rounded-2xl "
            ></textarea>
          </div>
          <div className="flex justify-center mt-4">
            <button
              type=""
              className="uppercase bg-red-500 mt-4 text-white px-4 py-1 rounded rounded-full"
            >
              Update
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default UpdateService
